import debounce from 'lodash.debounce';

export const useDebounce = (fn: () => void, delay: number) => {
  return debounce(
    () => {
      fn();
    },
    delay,
    { leading: false }
  );
};
